import { TooltipProps } from '@material-ui/core/Tooltip';

const MuiTooltip: Partial<TooltipProps> = {
    arrow: true,
};

export default MuiTooltip;
